import React from "react";

/**
 * StarRating — display or interactive star rating (1..5).
 *
 * Props:
 *  - value: number (0..5, supports halves visually when readOnly)
 *  - onChange: (v:number)=>void (only used when not readOnly)
 *  - readOnly: bool
 *  - size: tailwind size class (default text-xl)
 *  - color: 'amber' (default) | 'slate'
 */
export default function StarRating({ value = 0, onChange, readOnly = false, size = "text-xl", testIdPrefix = "star" }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className={`inline-flex items-center gap-1 ${size}`} role={readOnly ? undefined : "radiogroup"}>
      {stars.map((n) => {
        const filled = value >= n;
        const half = !filled && value >= n - 0.5;
        const icon = filled ? "fa-solid fa-star" : half ? "fa-solid fa-star-half-stroke" : "fa-regular fa-star";
        const cls = `${icon} ${filled || half ? "text-amber-400" : "text-slate-300"} ${readOnly ? "" : "cursor-pointer hover:text-amber-500"}`;
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            aria-checked={value === n}
            role={readOnly ? undefined : "radio"}
            aria-label={`${n} ${n === 1 ? "estrella" : "estrellas"}`}
            data-testid={`${testIdPrefix}-${n}`}
            onClick={() => !readOnly && onChange && onChange(n)}
            className="bg-transparent border-0 p-0 leading-none focus:outline-none"
          >
            <i className={cls}></i>
          </button>
        );
      })}
    </div>
  );
}
